import React from 'react';
import './AboutUs.css';

function PrivacyPolicy() {
  return (
    <div className="about-us-container">
      <h1>Privacy Policy</h1>

      <section className="about-section">
  <p>
    <strong>1. Data Collection and Usage</strong><br />
    At JALM, we prioritize simplicity and transparency. When users interact with our platform,
     we may collect basic personal and business information such as names, email addresses, 
     contact details, product listings, tax settings, and invoice records. This information is 
     solely used to operate core features—like invoice generation, user support, and account
      customization—ensuring smooth functionality across devices.
  </p>
</section>

<section className="about-section">
  <p>
    <strong>2. Data Security and Protection</strong><br />
    We employ industry-standard security measures to safeguard user data against unauthorized access,
     loss, or misuse for registered users. Your business data, billing records, and invoice histories are stored securely
      with encryption protocols wherever applicable. Access to this data is restricted to necessary 
      JALM systems and services that facilitate core operations. We do not sell or trade user data under any circumstances.
  </p>
</section>

<section className="about-section">
  <p>
    <strong>3. Third-Party Integrations</strong><br />
    JALM integrates with platforms such as WhatsApp and email providers to offer seamless invoice sharing.
     These services operate independently, and users are responsible for reviewing their respective privacy policies.
      We ensure no sensitive data is transmitted without explicit user initiation and aim to keep integrations secure and efficient.
  </p>
</section>

<section className="about-section">
  <p>
    <strong>4. User Rights and Control</strong><br />
    JALM users have full control over their business data. You may update, delete, or export your records
     at any time through your dashboard. If you wish to deactivate your account or erase stored information for registered users and
      our support team will process such requests within a reasonable time frame, subject to legal and operational considerations.
  </p>
</section>

<section className="about-section">
  <p>
    <strong>5. Updates and Transparency</strong><br />
    Our privacy policy may evolve to reflect product upgrades or compliance changes. 
    All updates will be posted clearly on the site, and we encourage users to check periodically 
    for the latest version. If significant changes arise, users may be notified via email or in-app alerts.
     We’re committed to transparency and protecting your trust in JALM.
  </p>
</section>

    </div>
  );
}

export default PrivacyPolicy;
